// extracted by mini-css-extract-plugin
export default {"ArrowBtn":"arrowBtn_ArrowBtn__PwaHK","Up":"arrowBtn_Up__SdRb1","Down":"arrowBtn_Down__tVSfA","Left":"arrowBtn_Left__wjSnA","Right":"arrowBtn_Right__HDDIH"};